(() => {
  const shippingCountry = document.getElementById('AddressCountry_Shipping');
  const countryState = document.getElementById('AddressProvince_shipping');
  const shippingCountryZip = document.getElementById('ShippingAddressZip');
  const shippingRatePackage = document.querySelector('.shipping_rate_package');
  const shippingAddressWrapper = document.querySelector('.shipping_rate_message');
  const shippingAddressCount = document.querySelector('.shipping_address_count');
  const item = document.querySelector('.shipping_calc_save');

  if (window.Shopify && Shopify.CountryProvinceSelector && shippingCountry && countryState) {
    new Shopify.CountryProvinceSelector('AddressCountry_Shipping', 'AddressProvince_shipping', {
      hideElement: 'AddressProvinceContainerNewShiping'
    });
  }

  function enhanceSelectWithCustomDropdown(selectEl, placeholderText) {
    if (!selectEl || selectEl.dataset.customEnhanced) return;
    selectEl.dataset.customEnhanced = "true";

    const parent = selectEl.parentElement;
    parent.classList.add('has-custom-dropdown');

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-select-wrapper';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'custom-select-trigger';
    trigger.setAttribute('aria-expanded', 'false');

    const label = document.createElement('span');
    label.className = 'custom-select-label';

    const arrow = document.createElement('span');
    arrow.className = 'custom-select-arrow';
    arrow.innerHTML = `<svg aria-hidden="true" focusable="false" width="10" height="6" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>`;

    trigger.appendChild(label);
    trigger.appendChild(arrow);

    const dropdown = document.createElement('div');
    dropdown.className = 'custom-select-dropdown';

    const list = document.createElement('ul');
    list.className = 'custom-select-options';
    dropdown.appendChild(list);

    wrapper.appendChild(trigger);
    wrapper.appendChild(dropdown);
    parent.appendChild(wrapper);

    function updateOptions() {
      list.innerHTML = '';
      const selectedIndex = selectEl.selectedIndex >= 0 ? selectEl.selectedIndex : 0;
      const selectedOpt = selectEl.options[selectedIndex];
      label.textContent = selectedOpt ? selectedOpt.text : (placeholderText || 'Select...');

      Array.from(selectEl.options).forEach((opt, idx) => {
        if (opt.value === '---' && selectEl.id === 'AddressProvince_shipping') return;
        const li = document.createElement('li');
        li.className = 'custom-select-option' + (idx === selectedIndex ? ' selected' : '');
        li.textContent = opt.text;
        li.dataset.value = opt.value;
        li.addEventListener('click', (e) => {
          e.stopPropagation();
          selectEl.value = opt.value;
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));
          label.textContent = opt.text;
          list.querySelectorAll('.custom-select-option').forEach(el => el.classList.remove('selected'));
          li.classList.add('selected');
          closeDropdown();
        });
        list.appendChild(li);
      });
    }

    function openDropdown() {
      document.querySelectorAll('.custom-select-wrapper.open').forEach(el => {
        if (el !== wrapper) {
          el.classList.remove('open');
          const tr = el.querySelector('.custom-select-trigger');
          if (tr) tr.setAttribute('aria-expanded', 'false');
        }
      });
      wrapper.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
      const selectedItem = list.querySelector('.custom-select-option.selected');
      if (selectedItem) {
        selectedItem.scrollIntoView({ block: 'nearest' });
      }
    }

    function closeDropdown() {
      wrapper.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      if (wrapper.classList.contains('open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) {
        closeDropdown();
      }
    });

    const observer = new MutationObserver(() => {
      updateOptions();
    });
    observer.observe(selectEl, { childList: true, subtree: true, attributes: true });

    selectEl.addEventListener('change', () => {
      updateOptions();
    });

    updateOptions();
  }

  if (shippingCountry) enhanceSelectWithCustomDropdown(shippingCountry, 'Select country');
  if (countryState) enhanceSelectWithCustomDropdown(countryState, 'Select state');

  if (!item || !shippingCountry || !shippingRatePackage) {
    return;
  }

  function escapeText(str) {
    const div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  item.addEventListener('click', () => {
    shippingRatePackage.innerHTML = '';
    const countryVal = shippingCountry.value;
    const zipVal = shippingCountryZip ? shippingCountryZip.value : '';
    const stateVal = countryState ? countryState.value : '';

    if (countryVal && countryVal !== "---") {
      item.classList.add('loading');
      const url = `/cart/shipping_rates.json?shipping_address%5Bzip%5D=${encodeURIComponent(zipVal)}&shipping_address%5Bcountry%5D=${encodeURIComponent(countryVal)}&shipping_address%5Bprovince%5D=${encodeURIComponent(stateVal)}`;

      fetch(url)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(window.shipping?.wrong_message || "Could not calculate shipping rate.");
          }
        })
        .then((response) => {
          item.classList.remove('loading');

          if (shippingAddressWrapper) shippingAddressWrapper.classList.remove('no-js-inline');
          if (shippingAddressCount && response.shipping_rates) {
            shippingAddressCount.innerText = `${response.shipping_rates.length}`;
          }
          if (response.shipping_rates && Array.isArray(response.shipping_rates)) {
            response.shipping_rates.forEach((rate) => {
              const text = document.createElement("p");
              text.setAttribute("class", 'mb-0');
              const currency = window.shopCurrencySymbol || "₹";
              text.textContent = `${rate.name}: ${currency}${rate.price}`;
              shippingRatePackage.appendChild(text);
            });
          }
        })
        .catch((e) => {
          item.classList.remove('loading');
          if (shippingAddressWrapper) shippingAddressWrapper.classList.add('no-js-inline');
          shippingRatePackage.innerHTML = `<p class="error mt-15">${escapeText(e.message || e)}</p>`;
        });
    } else {
      if (shippingAddressWrapper) shippingAddressWrapper.classList.add('no-js-inline');
      const countryLabel = window.shipping?.country_label || "Please select a country";
      shippingRatePackage.innerHTML = `<p class="error mt-15">${escapeText(countryLabel)}</p>`;
    }
  });
})();